export const getPopupContainer = (triggerNode: HTMLElement) => {
  return triggerNode?.parentElement as HTMLElement;
};
